import { DataBean } from "../DataBean";

export class CostProductionOrderCatalog extends DataBean {
    
    
    
 public async getCostProductionOrderConsolidated(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostProductionOrderConsolidated_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }
    public async getCostProductionOrderCatalog(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostProductionOrderCatalog_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }

}